// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"189c758a","416":"b69e77ac","567":"32bc6976","697":"98069f7b"}[chunkId] + ".chunk.js";
};